// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalOptionTypesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalOptionTypesFilter>;
}>;


export type GlobalOptionTypesQuery = { __typename?: 'Query', globalOptionTypes: Array<{ __typename?: 'GlobalOptionType', id: string, name: string, status: Types.GlobalOptionTypeStatus, globalOptionsCount: number, isElevation: boolean, isPlanPackage: boolean, allowsLocations: boolean }> };

export type GlobalOptionTypeFragment = { __typename?: 'GlobalOptionType', id: string, name: string, status: Types.GlobalOptionTypeStatus, globalOptionsCount: number, isElevation: boolean, isPlanPackage: boolean, allowsLocations: boolean };

export const GlobalOptionTypeFragmentDoc = gql`
    fragment GlobalOptionType on GlobalOptionType {
  id
  name
  status
  globalOptionsCount
  isElevation
  isPlanPackage
  allowsLocations
}
    `;
export const GlobalOptionTypesDocument = gql`
    query GlobalOptionTypes($filter: GlobalOptionTypesFilter) {
  globalOptionTypes(filter: $filter) {
    ...GlobalOptionType
  }
}
    ${GlobalOptionTypeFragmentDoc}`;

/**
 * __useGlobalOptionTypesQuery__
 *
 * To run a query within a React component, call `useGlobalOptionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGlobalOptionTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>(GlobalOptionTypesDocument, options);
      }
export function useGlobalOptionTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>(GlobalOptionTypesDocument, options);
        }
// @ts-ignore
export function useGlobalOptionTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>;
export function useGlobalOptionTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionTypesQuery | undefined, GlobalOptionTypesQueryVariables>;
export function useGlobalOptionTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>(GlobalOptionTypesDocument, options);
        }
export type GlobalOptionTypesQueryHookResult = ReturnType<typeof useGlobalOptionTypesQuery>;
export type GlobalOptionTypesLazyQueryHookResult = ReturnType<typeof useGlobalOptionTypesLazyQuery>;
export type GlobalOptionTypesSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionTypesSuspenseQuery>;
export type GlobalOptionTypesQueryResult = ApolloReactCommon.QueryResult<GlobalOptionTypesQuery, GlobalOptionTypesQueryVariables>;